import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store';
import navguard from '@/navguard';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () => import('../views/login.vue')
  },
  {
    path: '/password/reset/:uid',
    name: 'resetpassword',
    component: () => import('../views/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/orderforevent',
    name: 'orderforevent',
    component: () => import('../views/orderForEvent.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('../views/checkout.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/payment.vue')
  },
  {
    path: '/ordereventschedule',
    name: 'ordereventschedule',
    component: () => import('../views/orderEventSchedule.vue')
  },
  {
    path: '/thankyou/:date/:time?',
    name: 'thankyou',
    component: () => import('../views/thankyou.vue')
  },
  {
    path: '/ordersubscription',
    name: 'ordersubscription',
    component: () => import('../views/orderSubscription.vue')
  },
  {
    path: '/product',
    name: 'product',
   
    component: () => import('../views/product.vue')
  },
  {
    path: '/editsubscription',
    name: 'editsubscription',
   
    component: () => import('../views/product.vue')
  },
  {
    path: '/orderschedule/:edit?',
    name: 'orderschedule',
    component: () => import('../views/orderEventSchedule.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//NAVIGATION GUARD CHECKER
router.beforeEach( async (to, from, next) => {
  return navguard({to, from, next, store});
});

export default router
